import Controls from "../components/Controls";
import RoomPage from "../components/RoomPage";

type ExhibitPageProps = {
  variant: "residence" | "dining";
};

export default function ExhibitPage({ variant }: ExhibitPageProps) {
  const isResidence = variant === "residence";
  return <RoomPage
    roomId={isResidence ? "residence" : "dining"}
    slug={isResidence ? "rezidencia" : "talalo"}
    heroClassName={isResidence ? "residence-room-hero" : undefined}
    navigation={<Controls
          backTo={isResidence ? "/hogyan-mukodik" : "/rezidencia"}
          nextTo={isResidence ? "/talalo" : "/talalo/feladat"}
        />}
  />;
}
